// extracted by mini-css-extract-plugin
module.exports = {"launcher":"ZendeskChatPlugin_launcher__1cjoW","icon":"ZendeskChatPlugin_icon__Z19Qf mr-3"};